//
//
//      用户加载，保存，选择，撤销，重做        删除，复位
//
//
import File from "../mixin/File.js";
import Drop from "../mixin/tui-dropper";
export default {
    mixins: [File, Drop],
    methods: {
        FirstLoad() {
            //用户加载过一张图后，才能开始使用画笔等工具
            this.inpFileLoad.first().click();
        },
        InitDrop() {
            function jQ(str) {
                return window.$(str);
            }
            var _this = this;
            var imageEditor = window.imageEditor;
            var dropArea = jQ('.before')[0];
            this.AttchDropper(dropArea, false, function (fileLoad) {
                _this.fileLoad = fileLoad; //记录一下，一键还原用
                imageEditor
                    .loadImageFromFile(fileLoad)
                    .then(function () {
                        imageEditor.clearUndoStack(); //清理堆栈，防止能撤销
                        window.editorUrls.push(fileLoad);
                        window.picIndex = window.editorUrls.length - 1;
                        //防止再点最后一张会跳框
                        _this.renderImages(_this.getObjectURL(fileLoad));
                        _this.rePage();
                        _this.ReUI();
                        _this.ShowImgSize(fileLoad);
                        //缩略图，能到这里，就说明不是 undefined
                        jQ('.filename').find('input').val(fileLoad.name);
                        jQ(".before").hide();
                        jQ(".right").show();
                    });
            });
        },
        InitBasic() {
            function jQ(str) {
                return window.$(str);
            }
            var _this = this;
            var inputFileLoad = _this.inpFileLoad;
            var imageEditor = window.imageEditor;
            var spAPI = !!(window.File && window.FileList && window.FileReader);
            var btnMoreLoad = jQ(".btn-more-load");
            btnMoreLoad.on("click", function () {
                if (_this.imageList.length > 0) {
                    //第一次直接上下渲染，之后才跳提示框
                    window.picAction = 'newPic';
                    window.tuiHint.show();
                } else {
                    inputFileLoad.first().click();
                }
            });
            inputFileLoad.on("change", function (e) {
                if (!spAPI) {
                    console.log("当前浏览器不支持 file-api");
                    return;
                }
                var fileLoad = _this.fileLoad = e.target.files[0];
                inputFileLoad.val(''); //可以加载相同图片
                imageEditor
                    .loadImageFromFile(fileLoad)
                    .then(function () {
                        imageEditor.clearUndoStack(); //清理堆栈，防止能撤销
                        window.editorUrls.push(fileLoad);
                        window.picIndex = window.editorUrls.length - 1;
                        //防止再点最后一张会跳框
                        _this.renderImages(_this.getObjectURL(fileLoad));
                        _this.rePage();
                        _this.ReUI();
                        _this.ShowImgSize(fileLoad);
                        //缩略图，能到这里，就说明不是 undefined
                        jQ('.filename').find('input').val(fileLoad.name);
                        jQ(".before").hide();
                        jQ(".right").show();
                    })
                    .catch(function () {});
                //这里是用户主动选图，如果点开窗口，再取消按钮，会报错
            });
            // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
            //转画布 ◆ ◆ ◆
            var inputRotateF = jQ(".range-rotate-tes");
            inputRotateF.on("input", function () {
                var a = inputRotateF.val();
                var ang = parseInt(a, 10);
                imageEditor.setAngle(ang);
            });
            //画笔 ◆ ◆ ◆
            var btnDrawFree = jQ(".btn-draw-tes");
            btnDrawFree.on("click", function () {
                StartDraw();
            });

            function StartDraw() {
                imageEditor.stopDrawingMode();
                var brushWidth = 3;
                var brushOpacity = 70;
                var brushColor = "#fe3f7f";
                var finCol = window.colPick.hexToRGBa(brushColor, brushOpacity);
                var finOption = {
                    width: brushWidth,
                    color: finCol
                };
                imageEditor.startDrawingMode("FREE_DRAWING", finOption);
            }
        }
    }
};